var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{attrs:{"auto-resize":"","highlight-hover-row":"","toolbar-config":_vm.tableToolbar,"data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":_vm.tableHeight - 6,"show-footer":"","footer-method":_vm.amount,"size":"small","resizable":"","border":"","seq-config":{
      startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize,
    }},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"status",fn:function(ref){
    var row = ref.row;
return [_c('el-tag',{attrs:{"size":"mini","type":row.orderStatus === 'D' || row.orderStatus === 'T'
            ? 'danger'
            : row.orderStatus === 'R'
            ? 'warning'
            : row.orderStatus === 'Y' ||
              row.orderStatus === 'P' ||
              row.orderStatus === 'C'
            ? 'success'
            : 'light'}},[_vm._v(" "+_vm._s(row.v_orderStatus)+" ")])]}},{key:"showTeamName",fn:function(ref){
            var row = ref.row;
return [_vm._v(" "+_vm._s(row.depName)+"-"+_vm._s(row.teamName)+" ")]}},{key:"v_qty",fn:function(ref){
            var row = ref.row;
return [_vm._v(" "+_vm._s(row.v_qty)+" ")]}},{key:"showSales",fn:function(ref){
            var row = ref.row;
return [_vm._v(" "+_vm._s(row.v_salePriceAmount)+" ")]}},{key:"empty",fn:function(ref){return [_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/image/static/img/nodata.png"}}),_c('p',{staticClass:"no-data"},[_vm._v(" "+_vm._s(_vm.$l('INDEX.tips_no_data') || '暂无数据！')+" ")])])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }